'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = client;
exports.loadClient = loadClient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_CLIENT = 'binary/client/LOAD_CLIENT';
var LOAD_CLIENT_SUCCESS = 'binary/client/LOAD_CLIENT_SUCCESS';
var LOAD_CLIENT_FAIL = 'binary/client/LOAD_CLIENT_FAIL';

var initialState = {
  loadedClient: false,
  loadingClient: false,
  theme: false
};

function client() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_CLIENT:
      return (0, _extends3.default)({}, state, {
        loadingClient: true
      });
    case LOAD_CLIENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingClient: false,
        loadedClient: true,
        data: action.result
      });
    case LOAD_CLIENT_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingClient: false,
        loadedClient: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadClient(clientId) {
  return {
    types: [LOAD_CLIENT, LOAD_CLIENT_SUCCESS, LOAD_CLIENT_FAIL],
    promise: function promise(promiseClient) {
      return promiseClient.get('/feedback/' + clientId + '/details', {
        params: {}
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/client.js
// module id = 607
// module chunks = 0